import { IconBriefcase, IconX, IconEdit, IconUsers } from "@tabler/icons-react";
import m from "../../../../components/Modal/modal.module.css";
import s from "./jobDetails.module.css";
import jobStyles from "../jobs.module.css";
import Button from "../../../../components/UI/Button/button";
import clsx from "clsx";
import { statusClasses } from "../../../../components/JobCard/JobCard";
import moment from "moment";
import { currencyFormat } from "../../../../utils/functions";

const STATUS_LABEL = {
  active: "Active",
  "in-progress": "Active",
  "in-review": "In Review",
  draft: "Draft",
  archived: "Archived",
  completed: "Completed",
  closed: "Closed",
  cancelled: "Closed",
};

const STATUS_CLASS = {
  active: jobStyles.statusActive,
  "not-started": jobStyles.statusArchived,
  "in-progress": jobStyles.statusActive,
  "in-review": jobStyles.statusReview,
  draft: jobStyles.statusDraft,
  archived: jobStyles.statusArchived,
  completed: jobStyles.statusCompleted,
  closed: jobStyles.statusClosed,
  cancelled: jobStyles.statusClosed,
};

export default function JobDetailsModal({
  job,
  open,
  onClose,
  onViewApplicants,
  onRequestClose,
  onEdit,
  loading,
  applicants,
}) {
  if (!open || !job) return null;
  const jobStatus = job?.jobStatus?.toLowerCase();
  const status = job?.status?.toLowerCase() === "draft" ? "draft" : jobStatus;

  return (
    <div
      className={m.backdrop}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className={`${m.card} ${m.cardMd}`}>
        <div className={m.head}>
          <div
            className={clsx(m.headIcon, statusClasses[status])}
            // style={{ background: job.iconBg, color: job.iconFg }}
          >
            <IconBriefcase size={22} />
          </div>
          <div className={m.headInfo}>
            <div className={m.headTitle}>{job?.title}</div>
            <div className={m.headSub}>
              {STATUS_LABEL[status] && (
                <span className={`${jobStyles.statusChip} ${STATUS_CLASS[status]}`}>
                  {STATUS_LABEL[status]}
                </span>
              )}
              <span>Posted {moment(job?.createdAt).format("D MMMM YYYY")}</span>
            </div>
          </div>
          <button className={m.closeBtn} onClick={onClose} aria-label="Close">
            <IconX size={17} />
          </button>
        </div>

        <div className={m.body}>
          {loading ? (
            <div className="flex gap-3 items-center justify-center mb-4">
              <div className="h-5 w-5 animate-spin rounded-full border-2 border-[#e6eaf2] border-t-transparent" />
            </div>
          ) : (
            <div className={s.stats}>
              <div className={s.stat}>
                <div className={s.statVal}>{applicants?.length}</div>
                <div className={s.statLbl}>Applicants</div>
              </div>
              <div className={s.stat}>
                <div className={s.statVal}>{job?.views ?? 0}</div>
                <div className={s.statLbl}>Views</div>
              </div>
              <div className={s.stat}>
                <div className={s.statVal}>
                  {job.avgMatch ? `${job?.avgMatch}%` : "—"}
                </div>
                <div className={s.statLbl}>Avg Match</div>
              </div>
            </div>
          )}

          <div className={s.detailGrid}>
            <div className={s.detailCell}>
              <div className={s.detailCellLabel}>Salary</div>
              <div className={s.detailCellVal}>
                &#8358;{currencyFormat(Number(job?.budget ?? 0))}
              </div>
            </div>
            <div className={s.detailCell}>
              <div className={s.detailCellLabel}>Job Type</div>
              <div className={s.detailCellVal}>{job?.jobType}</div>
            </div>
            <div className={s.detailCell}>
              <div className={s.detailCellLabel}>Work Mode</div>
              <div className={s.detailCellVal}>{job?.workMode}</div>
            </div>
            <div className={s.detailCell}>
              <div className={s.detailCellLabel}>Duration</div>
              <div className={s.detailCellVal}>{job?.duration}</div>
            </div>
            <div className={s.detailCell}>
              <div className={s.detailCellLabel}>Relocation</div>
              <div className={s.detailCellVal}>
                {job?.hasNoRelocationPlans?.toLowerCase() === "yes"
                  ? "No Relocation"
                  : "Willing to Relocate"}
              </div>
            </div>
            <div className={s.detailCell}>
              <div className={s.detailCellLabel}>Status</div>
              <div className={s.detailCellVal}>
                {STATUS_LABEL[job?.jobStatus]}
              </div>
            </div>
          </div>

          <div className={s.section}>
            <div className={s.sectionTitle}>About this role</div>
            <div className={s.desc}>{job?.description}</div>
          </div>

          <div className={s.section}>
            <div className={s.sectionTitle}>Requirements</div>
            <ul className={s.reqList}>
              {job?.requirements?.map((r, i) => (
                <li key={i}>{r}</li>
              ))}
            </ul>
          </div>

          <div className={s.section}>
            <div className={s.sectionTitle}>Skills needed</div>
            <div className={s.skills}>
              {job?.skillsAndRequirements?.map((sk) => (
                <span key={sk} className={s.skill}>
                  {sk}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className={m.foot}>
          <Button
            variant="ghost"
            leftIcon={<IconX size={15} />}
            onClick={() => onRequestClose(job)}
          >
            Close Job
          </Button>
          <Button
            variant="primary"
            leftIcon={<IconEdit size={15} />}
            onClick={() => onEdit(job)}
          >
            Edit Job
          </Button>
          <Button
            variant="secondary"
            leftIcon={<IconUsers size={15} />}
            onClick={() => onViewApplicants(job)}
          >
            View Applicants
          </Button>
        </div>
      </div>
    </div>
  );
}
